import { SolidCard } from '@exxonmobil/react-unity';
import React from 'react';
import styled from 'styled-components';
import infoButton from './InfoButton';

interface Props {
  title: string;
  kicker: string;
  footer: any;
  icon?: any;
  info?: any;
}

const MainCard = ({ title, footer, kicker, icon, info }: Props) => (
  <StyledSolidCard>
    <SolidCardBody>
      <ContentContainer>
        {info ? (
          <InfoContentContainer>
            <SolidCardBodyTitle>{title}</SolidCardBodyTitle>
            <SolidCardBodyInfo>{infoButton(info)}</SolidCardBodyInfo>
          </InfoContentContainer>
        ) : (
          <SolidCardBodyTitle>{title}</SolidCardBodyTitle>
        )}
        {icon && <SolidCardBodyIcon>{icon}</SolidCardBodyIcon>}
      </ContentContainer>
      {kicker && <SolidCardBodyKicker>{kicker}</SolidCardBodyKicker>}
    </SolidCardBody>
    <SolidCardFooter style={{ padding: 0 }}>{footer}</SolidCardFooter>
  </StyledSolidCard>
);

const ContentContainer = styled('div')`
  flex-direction: row;
  display: flex;
  justify-content: space-between;
`;

const InfoContentContainer = styled('div')`
  flex-direction: row;
  display: flex;
  justify-content: left;
`;

const SolidCardBodyInfo = styled(SolidCard.Body.Icon)``;

const SolidCardBodyIcon = styled(SolidCard.Body.Icon)`
  display: inline;
  color: #fff;
`;

const StyledSolidCard = styled(SolidCard)`
  max-width: 100%;
  margin-bottom: 0.8rem;
`;

const SolidCardBody = styled(SolidCard.Body)`
  background-color: #111021;
  padding: 0.8rem;
`;

const SolidCardBodyTitle = styled(SolidCard.Body.Title)`
  color: #f5f5f5;
`;

const SolidCardBodyKicker = styled(SolidCard.Body.Kicker)`
  color: #f5f5f5;
`;

const SolidCardFooter = styled(SolidCard.Footer)`
  padding: 0;
`;

export default MainCard;
